import {ILeaderboardResponse, ILeaderboardState} from "./Helper";
import {createSlice, PayloadAction} from "@reduxjs/toolkit";
import {SliceNames} from "../constants";
import {getLeaderboard} from "./ActionCreators";

const initialValue: ILeaderboardState = {
    data: [],
    loading: false
}

const leaderboardSlice = createSlice({
    name: SliceNames.LEADERBOARD,
    initialState: initialValue,
    reducers: {},
    extraReducers: builder => {
        builder.addCase(
            getLeaderboard.pending, (state) => {
                state.loading = true
            })
            .addCase(
                getLeaderboard.fulfilled, (state, action: PayloadAction<ILeaderboardResponse[]>) => {
                    state.data = action.payload
                    state.loading = false
                })
            .addCase(
                getLeaderboard.rejected, (state) => {
                    state.loading = false
                })
    }
})

export default leaderboardSlice.reducer